/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import stringResource from 'ba-filter-nls';

export type OptionTypes = {
	value: string;
	label: string;
	inverted: string;
	invert: boolean;
	operation: string;
};

export default class ConditionTypeOptions {
	_options: OptionTypes[];
	constructor() {
		this._options = [
			// NOTE:
			// the value items below are used internally - they should not be changed.
			{
				value: 'equals',
				label: stringResource.get('equals'),
				inverted: stringResource.get('doesNotEqual'),
				invert: false,
				operation: 'equals',
			},
			{
				value: 'contains',
				label: stringResource.get('contains'),
				inverted: stringResource.get('doesNotContain'),
				invert: false,
				operation: 'contains',
			},
			{
				value: 'startsWith',
				label: stringResource.get('beginsWith'),
				inverted: stringResource.get('doesNotBeginWith'),
				invert: false,
				operation: 'startsWith',
			},
			{
				value: 'endsWith',
				label: stringResource.get('endsWith'),
				inverted: stringResource.get('doesNotEndWith'),
				invert: false,
				operation: 'endsWith',
			},
			{
				value: 'doesNotEqual',
				label: stringResource.get('doesNotEqual'),
				inverted: stringResource.get('equals'),
				invert: true,
				operation: 'equals',
			},
			{
				value: 'doesNotContain',
				label: stringResource.get('doesNotContain'),
				inverted: stringResource.get('contains'),
				invert: true,
				operation: 'contains',
			},
			{
				value: 'doesNotBeginWith',
				label: stringResource.get('doesNotBeginWith'),
				inverted: stringResource.get('beginsWith'),
				invert: true,
				operation: 'startsWith',
			},
			{
				value: 'doesNotEndWith',
				label: stringResource.get('doesNotEndWith'),
				inverted: stringResource.get('endsWith'),
				invert: true,
				operation: 'endsWith',
			},
		];
	}

	get list() {
		return this._options;
	}

	get defaultOption() {
		return this._options[1];
	}

	label(predicate) {
		let label = '';
		const option = this._options.find(item => predicate.conditionType === item.value);

		if (option) {
			label = predicate.invert === true ? option.inverted : option.label;
		}

		return label;
	}
}
